import AppService from "../services/app";
import * as types from "../actions/ActionTypes";

export const getInfo = () => {
  const service = new AppService();
  return {
    type: types.APP_INFO,
    payload: service["getInfo"]()
  }
}

export const getFlixxInfo = () => {
  const service = new AppService();
  return {
    type: types.GET_FLIXX_INFO,
    payload: service["getFlixxInfo"]()
  }
}

export const getLangs = async () => {
  const service = new AppService();
  return {
    type: types.GET_LANGS,
    payload: await service["getLangs"]()
  }
}

export const setScreen = screen => {
  return {
    type: types.SET_SCREEN,
    payload: screen
  }
};

export const setShowSidenav = () => {
  return {
    type: types.TOGGLE_SIDENAV
  }
};

export const setOpenModal = params => {
  return {
    type: types.OPEN_MODAL,
    payload: params
  }
};

export const setCloseModal = () => {
  return {
    type: types.CLOSE_MODAL,
  }
};